export const bookmark = {
  name: "bookmark" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.6 2.5a.9.9 0 0 1 .9-.9h15a.9.9 0 0 1 .9.9v19a.9.9 0 0 1-1.432.726L12 17.116l-6.968 5.11A.9.9 0 0 1 3.6 21.5v-19Zm1.8.9v16.324l6.068-4.45a.9.9 0 0 1 1.064 0l6.068 4.45V3.4H5.4Z" clip-rule="evenodd"/></svg>`,
  keywords: ["bookmark"],
  category: "action" as const,
};
